import React from "react";
import { Shimmer } from "@plum-xoxo/admin-dsm";
export class ImageContentLoader extends React.Component {
  getIndividualContent = () => {
    const { boxes, boxSize, height, width } = this.props;
    let contentRow = [];
    if (boxes > 0) {
      let contentColumn = [];
      for (let i = 0; i < boxes; i++) {
        contentColumn.push(
          <Shimmer
            className="box mb-12"
            variant="rectangular"
            width={width || 174.5}
            height={height || 138}
          />
        );
      }
      contentRow.push(contentColumn);
    } else {
      contentRow.push(
        <Shimmer
          className="box"
          variant="rectangular"
          width={width || 174.5}
          height={height || 138}
        />
      );
    }
    return contentRow;
  };

  render() {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          justifyContent: "space-between",
          gridColumnGap: "24px",
        }}
        className={this.props.className}
      >
        {this.getIndividualContent()}
      </div>
    );
  }
}

export default ImageContentLoader;
